import { Injectable } from '@angular/core';
import { CASH_DRAWER } from '../../data/cash-drawer';
import {
  LatestCashRegisterSession,
} from '../../model/cash-register-session';
import { Observable } from 'rxjs';
import { ICashDrawersApiService } from './cash-drawers-api.interface';
import { CreateRegisterRequestDto } from './dtos/create-register.request.dto';
import { CreateRegisterResponseDto } from './dtos/create-register.response.dto';
import { UpdateRegisterRequestDto } from './dtos/update-register.request.dto';
import { UpdateRegisterResponseDto } from './dtos/update-register.response.dto';
import { FindRegistersQueryDto } from './dtos/find-registers.query.dto';
import { FindRegistersResponseDto } from './dtos/find-registers.response.dto';
import { type GatewayDeviceResponseDto, type GatewayTransactionsResponseDto } from './dtos/gateway-device.response.dto';

@Injectable({
  providedIn: 'root',
})
export class CashDrawersMockApiService implements ICashDrawersApiService {
  public cashDrawer: LatestCashRegisterSession;

  constructor() {
    this.cashDrawer = CASH_DRAWER;
  }

  // Cash register methods
  findRegisters(
    query: FindRegistersQueryDto,
  ): Promise<FindRegistersResponseDto> {
    throw new Error('Method not implemented.');
  }
  createRegister(
    data: CreateRegisterRequestDto,
  ): Promise<CreateRegisterResponseDto> {
    throw new Error('Method not implemented.');
  }
  updateRegister(
    registerId: number,
    data: UpdateRegisterRequestDto,
  ): Promise<UpdateRegisterResponseDto> {
    throw new Error('Method not implemented.');
  }
  deleteRegister(id: number): Observable<void> {
    throw new Error('Method not implemented.');
  }
  deleteRegisters(ids: number[]): Observable<void> {
    throw new Error('Method not implemented.');
  }

  // Gateway device methods
  registerGatewayDevice(_registerId: number, _serialNumber?: string): Promise<GatewayDeviceResponseDto> {
    throw new Error('Method not implemented.');
  }

  getGatewayDevice(_registerId: number): Promise<GatewayDeviceResponseDto> {
    throw new Error('Method not implemented.');
  }

  toggleQrPh(_registerId: number, _isQrPhEnabled: boolean): Promise<GatewayDeviceResponseDto> {
    throw new Error('Method not implemented.');
  }

  getGatewayDeviceTransactions(_registerId: number, _pageNo?: number, _recPerPage?: number): Promise<GatewayTransactionsResponseDto> {
    throw new Error('Method not implemented.');
  }
}
